// third-party
import { FormattedMessage } from "react-intl";

import { NavItemType } from "types";

// assets
import {
  IconApps,
  IconUserCheck,
  IconBasket,
  IconMail,
  IconNfc,
} from "@tabler/icons";

// constant
const icons = {
  IconApps,
  IconUserCheck,
  IconBasket,
  IconMail,
  IconNfc,
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const application: NavItemType = {
  id: "application",
  title: <FormattedMessage id="application" />,
  icon: icons.IconApps,
  type: "group",
  children: [
    {
      id: "Form Wizard",
      title: <FormattedMessage id="Form Wizard" />,
      type: "item",
      url: "/user/dashboard",
    },
    {
      id: "Form Wizard",
      title: <FormattedMessage id="Form Wizard" />,
      type: "item",
      url: "/user/payment-prompt",
    },
    {
      id: "Form Wizard",
      title: <FormattedMessage id="Form Wizard" />,
      type: "item",
      url: "/user/form-details",
    },
    {
      id: "Upload Invoice",
      title: <FormattedMessage id="upload-invoice" />,
      type: "item",
      url: "/user/slip-upload",
    },
  ],
};

export default application;
